import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { DeliveryBanner } from '@carvana/merch-geolocation';
import { useCallback, useContext, useEffect, useRef } from 'react';
import {
  useSearchRequestId,
  useUserDeliveryInfo
} from '~/contexts/InventoryContext';
import ModalContext from '~/contexts/ModalContext';
import { useUserLocation } from '~/contexts/UserContext';
import getUserId from '~/utilities/getUserId';

function useSendEvent(shouldSend: boolean, zip: string) {
  const { trackEvent } = useContext(AnalyticsContext);
  const searchRequestId = useSearchRequestId();

  const zipRef = useRef(zip);
  useEffect(() => {
    zipRef.current = zip;
  }, [zip]);

  useEffect(() => {
    if (!shouldSend) return;

    trackEvent('Delivery Unavailable - Banner Shown', {
      userId: getUserId(),
      searchRequestId,
      zip: zipRef.current
    });
  }, [searchRequestId, shouldSend, trackEvent]);
}

export default function DeliveryBannerWrapper() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const { isDeliveryAllowed } = useUserDeliveryInfo() ?? {};
  const { zip = '' } = useUserLocation();

  const handleClick = useCallback(() => {
    trackEvent('Undeliverable banner - button clicked');
    setGeolocationModalOpen(true);
  }, [setGeolocationModalOpen, trackEvent]);

  const shouldDisplayBanner = isDeliveryAllowed === false && zip !== null;

  useSendEvent(shouldDisplayBanner, String(zip));

  return shouldDisplayBanner ? (
    <div className="mx-auto">
      <DeliveryBanner openCallback={handleClick} zip={zip} />
    </div>
  ) : null;
}
